'use client';

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Text,
} from '@chakra-ui/react';

interface Props {
  isOpen: boolean;
  onClose(): void;
  depreciations: AdaptedGiftcardDepreciation[];
  content: GiftcardsPagesLayoutContent['multiExpirationsModal'];
}

export const MultiExpirationModal = (props: Props) => {
  const { isOpen, onClose, depreciations, content } = props;

  const { title, description, creditTableHeader, expirationTableHeader } =
    content;

  return (
    <Modal
      isOpen={isOpen}
      isCentered
      onClose={onClose}
      motionPreset="slideInRight"
      size="lg"
    >
      <ModalOverlay />
      <ModalContent data-testid="multi-expirations-modal">
        <ModalHeader textAlign="center">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="3rem" fontSize="1.25rem">
          <Text>{description}</Text>

          <TableContainer mt="1.25rem">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th fontFamily="body" color="blue.800">
                    {creditTableHeader}
                  </Th>
                  <Th fontFamily="body" color="blue.800">
                    {expirationTableHeader}
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {depreciations.map(depreciation => (
                  <Tr key={`${depreciation.at}-${depreciation.amount}`}>
                    <Td>{depreciation.formatted.amount}</Td>

                    <Td>{depreciation.formatted.at}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
